module.exports = __webpack_public_path__ + "static/media/History.f3894df3.svg";